var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"label":_vm.label,"items":_vm.filteredRoles,"item-text":"description","item-value":"slug"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }